// ChildrenTable.js (з підтримкою резервних дітей та інтеграцією з AcceptChildrenNew)

import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSort,
  faSortUp,
  faSortDown,
  faEllipsisVertical
} from '@fortawesome/free-solid-svg-icons';

import placeType from '../../../../../data/placetype.json';
import { getChildrenListInfo, getChildrenListInfoLeft, removeChildDuplicate, restoreChild } from "../../actions";
import { localDateString } from "../../../../../components/helpers/datetranslate";
import { childrenscount } from "../../../../../components/helpers/wordsnumber";
import ActionsMenu from './menu';
import ChildDismissalModal from '../ChildrenOut/ChildDismissalModal';
import ChildTransferModal from '../ChildrenTransferModal/ChildTransferModal';
import ConfirmModal from '../../../../../components/ConfirmModal';
import AcceptChildrenNew from '../AcceptChildren/Acceptchildrennew';

import { sortData } from './sortUtils';

import './style.css';

const { translate } = placeType;

const translateFields = (data) => {
  return data.map((r, idx) => ({
    ...r,
    _id: r._id,
    _uniqueKey: `${r._id}_${idx}`,
    lastName: r.isReserv ? '-' : (r.lastName || ''),
    // Додаємо слово "(резерв)" після імені для резервних дітей
    firstName: r.isReserv ? `${r.firstName || 'резерв'} (резерв)` : (r.firstName || ''),
    middleName: r.isReserv ? '-' : (r.middleName || ''),
    birthDate: localDateString(r.birthDate),
    birthDateOrg: r.birthDate,
    documentNumber: r.isReserv ? '-' : (r.birthCertificate || ''),
    enrollmentDate: localDateString(r.dateFrom),
    dateLeft: localDateString(r.dateTo),
    placeType: translate[r.placeType],
    foodType: r?.typeKitchen == "diet" ? 'дієтичне' : 'звичайне',
    tPl: r.placeType,
    reestrKyiv: r.statusMR?.result == "true" ? 'Наявна' : '',
    tabelNumber: r.tabelNumber,
    status: r.status || '',
    isDuplicate: r.isDuplicate,
    outDate: localDateString(r.dateTo) || '—',
    isReserv: r.isReserv || false,
    requestInfo: r.requestInfo || null,
    currentStatus: r.currentStatus || null,
    inviteKg: r.inviteKg || null
  }));
}

const ChildrenTable = ({
  id, group_id,
  columnsConfig = [],
  onActionSelect,
  customProps = {},
  onChildrensList,
  groupNumber,
  groupName,
  allGroups,
  isArchive,
  period,
  selectedDate,
  mode,
  chgr,
  showRowNumber = true,
  defaultSort = { key: 'firstName', direction: 'asc' },
  isLeft = false,
  isAdmin,
  allGroupsList = [],
  userInfo = {},
  getGroupInfoByNumber = ()=>{}
}) => {

  const [data, setChildren] = useState([]);
  const [sortConfig, setSortConfig] = useState(defaultSort);
  const [expandedActions, setExpandedActions] = useState("internal");
  const [activeMenuIndex, setActiveMenuIndex] = useState(null);
  const [selectedChild, setSelectedChild] = useState({});
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [currentGroupInfo, setCurrentGroupInfo] = useState(null);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [selectedInviteData, setSelectedInviteData] = useState(null);
  
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({
    title: '',
    message: '',
    onConfirm: null,
    confirmText: 'Підтвердити',
    cancelText: 'Скасувати'
  });

  const defaultColumns = [
    {
      key: 'lastName',
      label: 'Прізвище',
      sortable: true,
      width: '12%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'firstName',
      label: "Ім'я",
      sortable: true,
      width: '10%',
      mode: ["all"],
      type: "text"
    },
    {
      key: 'middleName',
      label: 'По батькові',
      sortable: true,
      width: '12%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'birthDate',
      label: 'Дата народження',
      sortable: true,
      width: '10%',
      mode: ["all"],
      type: "date"
    },
    {
      key: 'documentNumber',
      label: 'Серія та номер свідоцтва про народження',
      sortable: true,
      width: '12%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'enrollmentDate',
      label: 'Дата зарахування',
      sortable: true,
      width: '10%',
      mode: ["all"],
      type: "date"
    },
    {
      key: 'placeType',
      label: 'Тип місця в групі',
      sortable: true,
      width: '10%',
      mode: ["all"],
      type: "text"
    },
    {
      key: 'foodType',
      label: 'Тип харчування',
      sortable: true,
      width: '12%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'reestrKyiv',
      label: 'наявність реєстрації',
      sortable: true,
      width: '6%',
      mode: ["all"],
      type: "text"
    },
    {
      key: 'actions',
      label: 'Дії',
      sortable: false,
      width: '6%',
      mode: ["edit"]
    }
  ];

  const defaultColumnsLeft = [
    {
      key: 'lastName',
      label: 'Прізвище',
      sortable: true,
      width: '12%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'firstName',
      label: "Ім'я",
      sortable: true,
      width: '10%',
      mode: ["all"],
      type: "text"
    },
    {
      key: 'middleName',
      label: 'По батькові',
      sortable: true,
      width: '12%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'birthDate',
      label: 'Дата народження',
      sortable: true,
      width: '10%',
      mode: ["all"],
      type: "date"
    },
    {
      key: 'documentNumber',
      label: 'Серія та номер свідоцтва про народження',
      sortable: true,
      width: '12%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'outDate',
      label: 'Дата вибуття',
      sortable: true,
      width: '10%',
      mode: ["edit"],
      type: "date"
    },
    {
      key: 'placeType',
      label: 'Тип місця в групі',
      sortable: true,
      width: '10%',
      mode: ["all"],
      type: "text"
    },
    {
      key: 'dateLeft',
      label: 'Дата відрахування',
      sortable: true,
      width: '12%',
      mode: ["all"],
      type: "text"
    },
    {
      key: 'reestrKyiv',
      label: 'наявність реєстрації',
      sortable: true,
      width: '6%',
      mode: ["edit"],
      type: "text"
    },
    {
      key: 'actions',
      label: 'Дії',
      sortable: false,
      width: '6%',
      mode: ["edit"]
    }
  ];

  const getColumnsWithRowNumber = useCallback(() => {
    let cols = columnsConfig.length > 0 ? columnsConfig : isLeft ? defaultColumnsLeft.filter(c => c.mode.includes(mode) || c.mode.includes("all")) : defaultColumns.filter(c => c.mode.includes(mode) || c.mode.includes("all"));
    
    if (showRowNumber) {
      const rowNumberColumn = {
        key: 'rowNumber',
        label: '№',
        sortable: false,
        width: '5%',
        type: 'number',
        mode: ["all"]
      };
      cols = [rowNumberColumn, ...cols];
    }
    
    return cols;
  }, [columnsConfig, mode, showRowNumber, isLeft]);

  const columns = getColumnsWithRowNumber();

  const fetchChildrenData = useCallback(async () => {
    if(isLeft) {
      const data = await getChildrenListInfoLeft({ id, group_id, period, selectedDate });
      const translatedData = translateFields(data);
      setChildren(translatedData);
    } else {
      const data = await getChildrenListInfo({ id, group_id, archives: isArchive, period, selectedDate });
      let childrens = ['attendance'].includes(mode) ? data.filter(ch => {
        if (ch.firstName && ch.firstName.match(/резерв/)) return false;
        if (new Date(selectedDate) < new Date(ch.dateFrom)) return false;
        return true;
      }) : data;

      const dupl = {};

      for(let i = 0; i < childrens.length; i++){
        if(childrens[i].isReserv) continue;
        if(!dupl[childrens[i]._id]) dupl[childrens[i]._id] = { count:0, arr: []};
        dupl[childrens[i]._id].count += 1;
        dupl[childrens[i]._id].arr.push(i);
      }

      const dupl_keys = Object.keys(dupl).filter(k=>dupl[k].count > 1);

      childrens.forEach((ch,i)=>{
        if(ch.isReserv) return;
        const {_id} = ch;
        const d_info = dupl_keys.find(k=> k == _id);
        if(d_info) {
          const {arr} = dupl[d_info];
          const ind = arr.findIndex(a=>a == i);
          if(ind > 0) {
            childrens[i]['isDuplicate'] = true;
            childrens[i]['lastName'] += ' (дублікат)';
          } 
        }
      });
      
      const translatedData = translateFields(childrens);
      setChildren(translatedData);
      
      if (onChildrensList) onChildrensList(childrens.map(r => ({ idChild: r._id, tPl: r.placeType })));
    }
  }, [id, group_id, isArchive, period, selectedDate, mode, isLeft, onChildrensList]);

  useEffect(() => {
    fetchChildrenData();
  }, [fetchChildrenData]);

  const showConfirmation = useCallback((title, message, onConfirm, confirmText = 'Підтвердити', cancelText = 'Скасувати') => {
    setConfirmConfig({
      title,
      message,
      onConfirm: () => {
        onConfirm();
        setShowConfirmModal(false);
      },
      confirmText,
      cancelText
    });
    setShowConfirmModal(true);
  }, []);

  const handleAcceptToGroup = useCallback(async (child) => {
    if (!child.requestInfo || !child.requestInfo.requestId) {
      alert('Немає інформації про заявку для оформлення');
      return;
    }
    
    const inviteData = {
      groupNumber: groupNumber,
      groupId: group_id,
      placeType: child.placeType || 'standart',
      periodStartYear: period || new Date().getFullYear(),
      kindergartenId: id
    };
    
    setSelectedChild(child);
    setSelectedRequestId(child.requestInfo.requestId);
    setSelectedInviteData(inviteData);
    setShowAcceptModal(true);
  }, [groupNumber, group_id, id, period]);

  const handleRemoveDuplicate = useCallback(async (child) => {
    if(!isAdmin) return alert('Ця функція доступна лише для адміністратора');
    showConfirmation(
      'Підтвердження видалення',
      `Видалити дублікат дитини ${child.firstName} ${child.lastName}?`,
      async () => {
        try {
          await removeChildDuplicate(id, group_id, child._id);
          alert('Дублікат видалений. Оновіть сторінку.');
          await fetchChildrenData();
        } catch (error) {
          console.error('Error removing duplicate:', error);
          alert('Помилка під час видалення дублікату');
        }
      }
    );
  }, [id, group_id, fetchChildrenData, showConfirmation, isAdmin]);

  const handleRestoreChild = useCallback(async (child) => {
    if(!isAdmin) return alert('Ця функція доступна лише для адміністратора');
    showConfirmation(
      'Підтвердження відновлення',
      `Відновити дитину ${child.firstName} ${child.lastName} у групі?\n\nДитина буде повернена до списку активної групи.`,
      async () => {
        try {
          await restoreChild(child._id, id, period, groupNumber);
          alert('Дитину відновлено');
          await fetchChildrenData();
        } catch (error) {
          console.error('Error restoring child:', error);
          alert('Помилка під час відновлення дитини');
        }
      }
    );
  }, [id, period, groupNumber, fetchChildrenData, showConfirmation, isAdmin]);

  const handleSort = (key) => {
    const column = columns.find(col => col.key === key);
    if (!column?.sortable) return;
    
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = useMemo(() => {
    if (data.length === 0) return data;
    
    const mainChildren = data.filter(child => !child.isReserv);
    const reservChildren = data.filter(child => child.isReserv);
    
    let sortedMain = mainChildren;
    if (sortConfig.key && mainChildren.length > 0) {
      const column = columns.find(col => col.key === sortConfig.key);
      const type = column?.type || 'text';
      sortedMain = sortData(mainChildren, sortConfig.key, sortConfig.direction, type);
    }
    
    let sortedReserv = reservChildren;
    if (sortConfig.key && reservChildren.length > 0) {
      const column = columns.find(col => col.key === sortConfig.key);
      const type = column?.type || 'text';
      sortedReserv = sortData(reservChildren, sortConfig.key, sortConfig.direction, type);
    }
    
    return [...sortedMain, ...sortedReserv];
  }, [data, sortConfig, columns]);

  const getSortIcon = (columnKey) => {
    if (columnKey !== sortConfig.key) return faSort;
    return sortConfig.direction === 'asc' ? faSortUp : faSortDown;
  };

  const handleMenuToggle = (index) => {
    setActiveMenuIndex(activeMenuIndex === index ? null : index);
  };

  const handleMenuClose = () => {
    setActiveMenuIndex(null);
  };

  const handleActionSelect = (actionId, child) => {
    if (actionId === 'rem_dup') {
      handleRemoveDuplicate(child);
      handleMenuClose();
      return;
    }
    
    if (actionId === 'restore') {
      handleRestoreChild(child);
      handleMenuClose();
      return;
    }
    
    if (actionId === 'accept_to_group') {
      handleAcceptToGroup(child);
      handleMenuClose();
      return;
    }
    
    if (["edit", "view"].includes(actionId)) {
      onActionSelect(actionId, child._id, group_id, child.tabelNumber, child.foodType);
    }

    setSelectedChild(Object.assign({}, child, {
      group: `${groupNumber} ${groupName}`,
      id: child._id
    }));

    setCurrentGroupInfo({
      _id: group_id,
      name: `${groupNumber} ${groupName}`
    });

    if (actionId === 'transfer') {
      setShowTransferModal(true);
      setExpandedActions("internal");
    } else if (actionId === 'withdraw') {
      setActiveMenuIndex("withdraw");
    } else if (actionId === 'transfer_external') {
      setExpandedActions("external");
      setShowTransferModal(true);
    }

    setActiveMenuIndex(actionId);
  };

  const handleAcceptSuccess = useCallback(() => {
    setShowAcceptModal(false);
    setSelectedRequestId(null);
    setSelectedInviteData(null);
    setSelectedChild({});
    fetchChildrenData();
  }, [fetchChildrenData]);

  if (!data || data.length === 0) return <div>не має дітей в групі на дату обліку відвідування</div>;

  const retMode = (child) => {
    const info = chgr?.find(ch => ch.childId == child._id);
    const tempMoved = info?.tempMoved?.dateFrom;
    if (tempMoved) return 'tempedit';
    return mode;
  };

  const renderCellValue = (child, column) => {
    if (column.key === 'rowNumber') return null;
    
    if (column.renderCell) {
      return column.renderCell(child, column, customProps);
    }
    
    let value = child[column.key];
    
    if (column.type === 'date' && value) {
      return value;
    }
    
    return value;
  };

  const getRowKey = (child, index) => {
    if (child._uniqueKey) return child._uniqueKey;
    return `${child._id}_${index}`;
  };

  const mainCount = data.filter(c => !c.isReserv).length;
  const reservCount = data.filter(c => c.isReserv).length;

  return (
    <div className="children-table-container">
      <ChildDismissalModal
        show={activeMenuIndex == "withdraw"}
        onHide={() => setActiveMenuIndex(null)}
        child={selectedChild}
        kgId={id}
        onSuccess={() => alert("Дитина вибута")}
      />
      <ChildTransferModal
        show={showTransferModal}
        onHide={() => setShowTransferModal(false)}
        child={selectedChild}
        kgId={id}
        currentGroup={currentGroupInfo}
        onSuccess={() => { }}
        allGroups={allGroups}
        mode={expandedActions}
      />
      
      <ConfirmModal
        show={showConfirmModal}
        onConfirm={confirmConfig.onConfirm}
        onCancel={() => setShowConfirmModal(false)}
        title={confirmConfig.title}
        message={confirmConfig.message}
        confirmText={confirmConfig.confirmText}
        cancelText={confirmConfig.cancelText}
      />

      <AcceptChildrenNew
        show={showAcceptModal}
        idreq={selectedRequestId}
        invite={selectedInviteData || {}}
        groups_info={allGroupsList}
        user_info={userInfo}
        onClose={handleAcceptSuccess}
        getGrInfo={getGroupInfoByNumber}
        kgId={id}
      />
      
      <div className="table-responsive">
        <table className="table align-middle" style={{ fontSize: '14px' }}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  style={{
                    width: column.width,
                    cursor: column.sortable ? 'pointer' : 'default',
                    color: '#262e35ff',
                    fontWeight: 600,
                    borderBottom: '1px solid #6c757d',
                    padding: '10px 8px'
                  }}
                  onClick={() => handleSort(column.key)}
                >
                  <div className="d-flex align-items-center">
                    {column.renderHeader ? column.renderHeader(column, customProps) : column.label}
                    {column.sortable && (
                      <FontAwesomeIcon
                        icon={getSortIcon(column.key)}
                        className="ms-1"
                        style={{ fontSize: '12px' }}
                      />
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedData.map((child, index) => {
              const isReservRow = child.isReserv;
              const reservClass = isReservRow ? 'table-warning' : (index % 2 === 0 ? '' : 'bg-light');
              
              return (
                <tr 
                  key={getRowKey(child, index)} 
                  className={reservClass}
                  style={isReservRow ? { backgroundColor: '#fff3cd' } : {}}
                >
                  {columns.map((column) => (
                    <td key={column.key} style={{ padding: '10px 8px', borderBottom: '1px solid #e9ecef', position: 'relative' }}>
                      {column.key === 'rowNumber' ? (
                        index + 1
                      ) : column.key === 'actions' ? (
                        <div className="actions-menu-container" style={{ position: 'relative', display: 'inline-block' }}>
                          <button
                            className="btn btn-sm btn-link text-decoration-none p-0"
                            onClick={() => handleMenuToggle(index)}
                            style={{ color: '#0069ff' }}
                          >
                            <FontAwesomeIcon icon={faEllipsisVertical} />
                          </button>

                          {activeMenuIndex === index && (
                            <ActionsMenu
                              onActionSelect={(actionId) => handleActionSelect(actionId, child)}
                              onClose={handleMenuClose}
                              mode={retMode(child)}
                              isLeft={isLeft}
                              isDuplicate={child.isDuplicate}
                              isReserv={child.isReserv}
                              currentStatus={child.currentStatus}
                            />
                          )}
                        </div>
                      ) : renderCellValue(child, column)}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="table-footer-note">
        Всього в групі {data.length} {childrenscount(data.length)}, 
        з них: основних - {mainCount}, резерв - {reservCount}.
        {reservCount > 0 && (
          <span className="text-warning ms-2">(резервні діти виділені жовтим)</span>
        )}
      </div>
    </div>
  );
};

export default ChildrenTable;